import React from 'react';

import { Box, Button, Divider, Drawer, Typography } from '@mui/material';

import { FlexRow, NoraButton, Spacer } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import ElementLocators from '../../../../common/ElementLocators';
import styles from '../styles.module.scss';

interface ISummaryDisagreeToRescindProps {
  selectedReason: string | null;
  description: string;
  showSummary: (val: boolean) => void;
  onConfirmClick: () => void;
  isOpen: boolean;
}

export default function SummaryDisagreeToRescind(
  props: ISummaryDisagreeToRescindProps,
) {
  return (
    <Drawer
      open={props.isOpen}
      anchor="right"
      variant="persistent"
      classes={{ paper: styles.Drawer }}
      transitionDuration={{ enter: 0, exit: 0 }}
    >
      <Box mt={6}>
        <Box
          m={3}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">
            {Resource.DISAGREE_TO_RESCIND}
          </Typography>
          <Button onClick={() => props.showSummary(false)}>
            <Typography variant="subtitle2" color="textSecondary">
              {Resource.BACK}
            </Typography>
          </Button>
        </Box>
        <Divider />
        <Box m={3}>
          <Spacer height={16} />
          <FlexRow className={styles.DrawerSubTitle}>{Resource.REASON}</FlexRow>
          <FlexRow>
            <p>{props.selectedReason}</p>
          </FlexRow>
          <Spacer height={16} />
          <Spacer height={16} />
          {props.description && (
            <>
              <FlexRow className={styles.DrawerSubTitle}>
                {Resource.DESCRIPTION}
              </FlexRow>
              <FlexRow>
                <p>{props.description}</p>
              </FlexRow>
            </>
          )}
        </Box>
      </Box>
      <Box>
        <NoraButton
          name={ElementLocators.LOCATOR_REVIEW_APPROVAL_BUTTON}
          className={styles.DrawerButton}
          onClick={props.onConfirmClick}
        >
          {Resource.CONFIRM_DECISION}
        </NoraButton>
      </Box>
    </Drawer>
  );
}
